var React = require('react');

function Logotype (props) {
    return React.createElement("svg",props,React.createElement("path",{"clipRule":"evenodd","d":"m246.1 295.1h-48.8v48.8l-97.7-97.6 97.7-97.7v48.8h48.8c27 0 48.8-21.9 48.8-48.8 0-27-21.8-48.8-48.8-48.8h-146.5v293h146.5c27 0 48.8-21.8 48.8-48.9.1-26.9-21.8-48.8-48.8-48.8zm140.2 91.4c77.5-23.5 121.2-105.4 97.7-182.8-14.2-46.8-50.9-83.4-97.7-97.7 14.9 49 3.1 102.1-31 140.2 34.1 38.2 45.9 91.4 31 140.3zm-384.3-384.4h341.9c134.8 0 244.1 109.3 244.1 244.2s-109.3 244.2-244.2 244.2h-341.8z","fillRule":"evenodd"}));
}

Logotype.defaultProps = {"enableBackground":"new 0 0 589 492","viewBox":"0 0 589 492"};

module.exports = Logotype;

Logotype.default = Logotype;
